import { useEffect, useState } from "react";
import { SelectWithFilter } from "../../../../utils/form";
import { useApi } from "../../../../utils/hooks";
import _ from "lodash";
import localStorageSlim from "localstorage-slim";
import config from "../../../../config";
import { useSearchParams } from "react-router-dom";

const { key: cacheKey, ttl: cacheTtl } = config.healthInsurances.cache;

const useFetchHealthInsurances = () => {
  //TODO improve this (patients token required for self register flow)
  const [searchParams] = useSearchParams();
  const token = searchParams.get("token");
  const api = useApi(token);
  const [healthInsurances, setHealthInsurances] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    (async () => {
      const cachedData = localStorageSlim.get(cacheKey);

    if (cachedData) {
      setHealthInsurances(cachedData);
      setIsLoading(false);
      return;
    }

    const data = await api.healthInsurances();
    setHealthInsurances(data);
    setIsLoading(false);

    localStorageSlim.set(cacheKey, data, { ttl: cacheTtl });
  })();
  }, []);

  return { healthInsurances, isLoading };
};


const HealthInsuranceSelect = ({ form: { control } }) => {
  const { healthInsurances, isLoading } = useFetchHealthInsurances();

  const healthInsurancesNames = _(healthInsurances).map(({ name }) => _.toUpper(name)).uniq().value();

  const isFromOurList = (value) =>
    healthInsurancesNames.some(
        name => _.toLower(_.trim(name)) === _.toLower(_.trim(value))
    );

  const validateHealthInsurance = (value) => {
    const manualPattern = /^[A-Za-zÁÉÍÓÚáéíóúÑñ\s.&(),'-]+$/;

    return isFromOurList(value) || manualPattern.test(value);
  };

  return <SelectWithFilter
      control={control}
      required
      validate={validateHealthInsurance}
      name="healthInsurance"
      label="Obra social/prepaga"
      helperText="Sin el código de plan. Si es particular, seleccioná 'Particular'"
      list={healthInsurancesNames}
      loading={isLoading}
    />
};

export default HealthInsuranceSelect;